import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fi";
import "dayjs/locale/sv";
import localizedFormat from "dayjs/plugin/localizedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { DEFAULT_LOCALE } from "../i18n/config";

export const TIMEZONE = "Europe/Helsinki";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

dayjs.tz.setDefault(TIMEZONE);
dayjs.locale(DEFAULT_LOCALE);

export type { Dayjs } from "dayjs";

export default dayjs;
